export default __webpack_public_path__ + "static/media/2 dots button.4517c6de.svg";